//import axios from "axios";

export const state = {
    connect: false,
    message: null,
    stateMessage: "waiting",
    result: {
        type:22
    }
}

export const getters = {
    getConnectState: state => state.connect,
    getStateMessage: state => state.stateMessage,
    getChangeWelly: state => state.result
}

export const mutations = {
    SOCKET_CONN_ESTABLISHED: (state, data) => {
        // eslint-disable-next-line
        console.log("SERVER - CLIENT >= CONNECTED",data)
        state.connect = true
    },
    SOCKET_DO_CHANGE:(state, result) => {
        state.result = result
    },
}

export const actions = {
    socket_connEstablished: (context, data) => {
        //console.log(data)
        context.commit("SOCKET_CONN_ESTABLISHED", data)
    },
    socket_doChange: (context, data) => {
        // eslint-disable-next-line
        console.log(data)
        context.commit("SOCKET_DO_CHANGE", data)
    }
}
/*
export default {
    state,
    getters,
    mutations,
    actions,
    namespaced:true
}
*/